var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_2012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 6.91667H18.3337M9.16699 10.5833V16.0833M12.8337 10.5833V16.0833M4.58366 6.91667L5.50033 17.9167C5.50033 18.4029 5.69348 18.8692 6.0373 19.213C6.38111 19.5568 6.84743 19.75 7.33366 19.75H14.667C15.1532 19.75 15.6195 19.5568 15.9634 19.213C16.3072 18.8692 16.5003 18.4029 16.5003 17.9167L17.417 6.91667M8.25033 6.91667V4.16667C8.25033 3.92355 8.3469 3.69039 8.51881 3.51849C8.69072 3.34658 8.92388 3.25 9.16699 3.25H12.8337C13.0768 3.25 13.3099 3.34658 13.4818 3.51849C13.6537 3.69039 13.7503 3.92355 13.7503 4.16667V6.91667",
    stroke: "#33303C",
    strokeOpacity: 0.6,
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_2012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.1c30ee28ad97f480f67ee98cb7602555.svg";
export { ForwardRef as ReactComponent };